import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('destockpro_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if already on login page or if this is the initial auth check
      const isLoginPage = window.location.pathname === '/connexion';
      const isAuthCheck = error.config?.url?.includes('/auth/me');
      
      if (!isLoginPage && !isAuthCheck) {
        localStorage.removeItem('destockpro_token');
        window.location.href = '/connexion';
      }
    }
    return Promise.reject(error);
  }
);

// Simple in-memory cache for static data (sectors, conditions)
const _cache = {};
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function cachedGet(url) {
  const now = Date.now();
  if (_cache[url] && (now - _cache[url].ts < CACHE_TTL)) {
    return Promise.resolve(_cache[url].data);
  }
  return api.get(url).then(r => {
    _cache[url] = { data: r, ts: now };
    return r;
  });
}

export default api;

export const BACKEND_URL = API_URL;
